export const SERVER_ADDRESS='afrocart.ca:8445';
export const WEB_ADDRESS= SERVER_ADDRESS.split(':')[0];
export const CDN_URL='https://d1cj84uou5e4ye.cloudfront.net';
export const AWS_BUCKET_NAME='afrocart';
export const RECORDING_CONFIG_ARN='arn:aws:ivs:us-east-1:975049943081:recording-configuration/ipgqjOCJPrPl';
export const CLOUDFRONT_DISTRIBUTIONS_ID='E1B6EMLYCIOJG6';
export const SUBNETS= ["subnet-0974e3f2a3914ad30","subnet-0b1c20c7c4ac00473","subnet-0baf3f79b8f641e68"];
export const AWS_REGION= "ca-central-1";  
export const S3_BASE_URL= "https://afrocart.s3.us-east-1.amazonaws.com";
export const DOCKER_AWS_REGION= "ca-central-1";
export const CONFIG= {
    "firebase": {
        "apiKey": "AIzaSyBD6XkL8ciWm9ipVvkCvpJ2CvGPhPP568Q",
        "authDomain": "afrocart-5340d.firebaseapp.com",
        "databaseURL": "https://afrocart-5340d-default-rtdb.firebaseio.com",
        "projectId": "afrocart-5340d",
        "storageBucket": "afrocart-5340d.appspot.com",
        "messagingSenderId": "163049755710",
        "appId": "1:163049755710:web:6bd6eb9037533611fd2d6f",
        "measurementId": "G-GPNG1W4X8C",
        "vapidKey": "BIxWbEsJFXe2YO8pWOd9z31y17Rgom6BBvZ7KhbPA1tKWq7TTCg8Bed4jqc6Udo0Ou9Pweoe4PlasntYyg4Rnlw"
    }
};